import { useFormContext } from "react-hook-form";
import { cn } from "@patient-watch/ui";
import { deSnakeCase } from "./services/deSnakeCase";

function messageToPlainText(message: unknown): string {
    if (typeof message === "string") {
        return message;
    }
    if (message == null) {
        return "";
    }
    if (typeof message === "number" || typeof message === "boolean" || typeof message === "bigint") {
        return String(message);
    }
    if (typeof message === "object") {
        return JSON.stringify(message);
    }
    return "";
}

interface ErrorsProps {
    className?: string;
}

const Errors = ({ className }: ErrorsProps) => {
    const form = useFormContext();
    return (
        <div>
            {form.formState.errors &&
                Object.entries(form.formState.errors).map(([fieldName, error]) => {
                    const msg =
                        error && typeof error === "object" && "message" in error
                            ? (error as { message?: unknown }).message
                            : undefined;
                    const text = messageToPlainText(msg);
                    return (
                        <p
                            className={cn(
                                "bg-red-200 px-4 py-2 border-red-300 border-y text-red-600 text-sm",
                                className
                            )}
                            key={fieldName}
                        >
                            {deSnakeCase(fieldName)}: {text}
                        </p>
                    );
                })}
        </div>
    );
};

export default Errors;
